// extracted by mini-css-extract-plugin
export default {"step1":"Step1_step1__cXmBl","heading":"Step1_heading__QS3dK","subHeading":"Step1_subHeading__iTysN","nextButton":"Step1_nextButton__nQv1l"};